export default __webpack_public_path__ + "static/media/reading.932325fc4bb22d3f97f66406ecc717b0.svg";